<template>
  <div
    ref="categoryRow"
    class="category-row"
    :class="{ dragging: isDragging }"
    @wheel="scrollHorizontally"
    @mousedown="startDragging"
    @mousemove="drag"
    @mouseup="stopDragging"
    @mouseleave="stopDragging"
  >
    <button
      v-for="category in categoryTabs"
      :key="category.category_id === null ? 'all' : category.category_id"
      type="button"
      class="category-pill"
      :class="{ active: isActive(category) }"
      @click="$emit('select', category.category_id)"
    >
      <i :class="category.icon"></i>
      {{ categoryLabel(category) }}
      <span v-if="category.count !== null">{{ category.count }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'RetailSaleProductCategoryTabs',
  updated() {
    if (this.categories !== this.readyCategories) {
      this.readyCategories = this.categories
      this.$emit('ready')
    }
  },
  data() {
    return {
      isDragging: false,
      dragStartX: 0,
      dragStartScrollLeft: 0,
      readyCategories: null
    }
  },
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    totalCount: {
      type: Number,
      default: 0
    },
    activeCategoryId: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    categoryTabs() {
      if (!this.categories.length) return []

      return [
        {
          category_id: null,
          labelKey: 'retailSale.categories.allItems',
          count: this.totalCount,
          icon: 'fas fa-th-large'
        },
        ...this.categories.map(category => ({
          ...category,
          count:
            category.products_count === undefined
              ? null
              : category.products_count
        }))
      ]
    }
  },
  methods: {
    categoryLabel(category) {
      if (category.labelKey) {
        return this.$t(category.labelKey)
      }

      if (this.$root.$i18n && this.$root.$i18n.locale === 'kh') {
        return category.category_name_kh || category.category_name_en
      }

      return category.category_name_en || category.category_name_kh
    },
    isActive(category) {
      if (category.category_id === null) {
        return this.activeCategoryId === null
      }

      return String(category.category_id) === String(this.activeCategoryId)
    },
    scrollHorizontally(event) {
      const row = this.$refs.categoryRow

      if (!row || row.scrollWidth <= row.clientWidth) return

      event.preventDefault()
      row.scrollLeft += event.deltaY || event.deltaX
    },
    startDragging(event) {
      const row = this.$refs.categoryRow

      if (!row || row.scrollWidth <= row.clientWidth) return

      this.isDragging = true
      this.dragStartX = event.pageX
      this.dragStartScrollLeft = row.scrollLeft
    },
    drag(event) {
      const row = this.$refs.categoryRow

      if (!this.isDragging || !row) return

      event.preventDefault()
      row.scrollLeft =
        this.dragStartScrollLeft - (event.pageX - this.dragStartX)
    },
    stopDragging() {
      this.isDragging = false
    }
  }
}
</script>

<style scoped src="../../styles/product-category-tabs.css"></style>
